export const matter_types = [
  'Immigration',
  'Asylum',
  'Civil',
  'Family'
];

export const initData = {
  date: '',
  case_details: '',
  matter_type: '',
  surname: '',
  forename: '',
  title: '',
  dob: '',
  marital_status: '',
  ni_number: '',
  ethnic_origin: '',
  disability: '',
  immigration_status: '',
  venue: '',
  stage: '',
  key_date: '',
  number_street: '',
  city: '',
  country: '',
  postal_code: '',
  telephone: '',
  mobile: '',
  id_carried_out: 'Yes',
  evidence_relied_upon: '',
  conflict_check: '',
  funding_source: '',
  sponsor_name: '',
  sponsor_number_street: '',
  sponsor_city: '',
  sponsor_country: '',
  sponsor_postal_code: '',
  sponsor_telephone: '',
  fee_earner: '',
  fixed_fee: '',
  fixed_fee_agreed: 'Yes',
  hourly_rate: '',
  hourly_rate_agreed: 'No',
  alternative_cost: '',
  completed_by: '',
  matter_description: '',
  user_id: '',
};
